import React from "react";

export function PageHeader({ eyebrow, title, subtitle, actions }) {
    return (
        <div className="border-b border-zinc-200 px-8 py-6">
            <div className="flex items-end justify-between gap-6">
                <div>
                    {eyebrow && (
                        <div className="tag-pill mb-3">{eyebrow}</div>
                    )}
                    <h1 className="text-4xl font-bold tracking-tight" data-testid="page-title">{title}</h1>
                    {subtitle && <p className="text-sm text-zinc-500 mt-2 max-w-2xl">{subtitle}</p>}
                </div>
                {actions && <div className="flex gap-2 items-center">{actions}</div>}
            </div>
        </div>
    );
}
